import { useQuery } from "@tanstack/react-query";
import { DropPoint } from "src/api/locations";
import { useShop } from "src/hooks/Utils/Shop/useShop";

import { OpenapiSingleton } from "src/utils/OpenapiSingleton";

interface GetDropPointParams {
  dropPointId: string;
  userId?: string;
  countryIso?: string;
  storeId?: number;
  type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT';
}


export default function useGetDropPointById(
  dropPointId: string,
  userId?: string,
  countryIso?: string,
  storeId?: number,
  type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT',
  isEnabled: boolean = true,
) {
  const { shopMarketId, shopLang } = useShop();
  
  const marketIdStr = typeof shopMarketId === 'number' ? String(shopMarketId) : shopMarketId;

  return useQuery<DropPoint, Error>({
    queryKey: ["getDropPoint", dropPointId, countryIso || marketIdStr, storeId , type],
    queryFn: () => getDropPointById(
      dropPointId,
      userId,
      countryIso || marketIdStr,
      storeId 
    ),
    enabled: isEnabled && !!dropPointId,
    onError: (error) => {
      console.error("Error fetching drop point by ID:", error);
    }
  });
}

export async function getDropPointById(
  dropPointId: string,
  customerId: string,
  marketIsoCode: string,
  storeId: number
): Promise<DropPoint | null> {
  try {
    const response = await OpenapiSingleton.DroppointApiSingle.getDropPoint(
      dropPointId,
      "web-standard", 
      "desktop", 
      customerId,
      marketIsoCode,
      storeId.toString(),
    );
    
    return response?.data || null;
  } catch (error) {
    console.error(`Failed to fetch drop point data for ID ${dropPointId}:`, error);
    return null;
  }
}